import { ECompareType, EQuestionActionsTypes } from '@cian/frontend-request-form-widget';
import { EFormFieldsNames, EQuestionCodes, EStepCodes } from '../../../../types/requestForm';
import { createFields } from '../utils/createFields';
import { createValidation } from '../utils/createValidation';
import { NEXT_BUTTON_TEXT } from '../../../../constants/requestForm/buttonText';
import { createField } from '../utils/createField';
import { EAddedAdsType } from '../../../../types/addedAdsType';
var FIELDS = [EFormFieldsNames.NewPhone, createField(EFormFieldsNames.Phone, {
  label: 'Старый телефон'
}), EFormFieldsNames.AddedAds];
export var CHANGED_PHONE_INITIAL_STEP = {
  code: EStepCodes.ChangedPhoneInitial,
  question: {
    code: EQuestionCodes.ChangedPhoneInitial,
    title: 'Изменился номер телефона (шаг 1 из 2)',
    fields: createFields(FIELDS),
    validation: createValidation(FIELDS),
    actions: [{
      type: EQuestionActionsTypes.NextQ,
      text: NEXT_BUTTON_TEXT
    }]
  },
  nextStep: [{
    conditions: [{
      answerField: EFormFieldsNames.AddedAds,
      compareType: ECompareType.Eq,
      value: [EAddedAdsType.No]
    }],
    nextStepCode: EStepCodes.ChangedPhoneSearcherFinal
  }, {
    conditions: [{
      answerField: EFormFieldsNames.AddedAds,
      compareType: ECompareType.Eq,
      value: [EAddedAdsType.Employee]
    }],
    nextStepCode: EStepCodes.ChangedPhoneEmployeeFinal
  }, {
    conditions: [],
    nextStepCode: EStepCodes.ChangedPhoneFinal
  }]
};